
import { useState } from "react";
import { UserData } from "./modal-sectors/UserData";
import { KitShipping } from "./modal-sectors/KitShipping";
import { Subscribers } from "./modal-sectors/Subscribers";
import { MoreInfo } from "./modal-sectors/MoreInfo";

export const MembershipInfo = ({ toggleModal, component,modalData,stateModel }) => {

  const [editInput, setEditInput] = useState(true)
  const [clickedBtn, setClickedBtn] = useState(1)


  const functionBtn = (e) => {
    const selectedBtn = Number(e.currentTarget.dataset.id)

    setClickedBtn(selectedBtn)
  }

  const editionEnable = () => {
    setEditInput(false)
  };

  const editionDisable = () => {
    setEditInput(true)
  };


  const renderContent = () => {
    switch (clickedBtn) {
      case 1:
        return <UserData

          toggleModal={toggleModal}
          editInput={editInput}
          editionDisable={editionDisable}
          editionEnable={editionEnable}
          isActive={true}
          userData={modalData}
        />

      case 2:
        return <KitShipping

          toggleModal={toggleModal}
          editInput={editInput}
          editionDisable={editionDisable}
          editionEnable={editionEnable}
          isActive={true}
          userData={modalData}
        />

      case 3:
        return <Subscribers

          toggleModal={toggleModal}
          isActive={true}
          userData={modalData}
          stateModel={stateModel}
        />
      case 4:
        return <MoreInfo

          toggleModal={toggleModal}
          isActive={true}
          userData={modalData}
        />
      default:
        return <div></div>
    }
  }


  return (

    <div className="modal-content contentWidht">

      <div className="modal-body mbody-class">


        <div className="btn-modal">

          <button
            className={`btn-modal-pages ${clickedBtn === 1 ? 'btn-active' : ''} `}
            data-id="1"
            onClick={functionBtn}>
            <span
              className="material-symbols-outlined notranslate mI-modal-buttons">
              person
            </span>
          </button>

          <button
            className={`btn-modal-pages ${clickedBtn === 2 ? 'btn-active' : ''} `}
            data-id="2"
            onClick={functionBtn} >
            <span
              className="material-symbols-outlined  notranslate mI-modal-buttons">
              deployed_code
            </span>
          </button>

          <button
            className={`btn-modal-pages ${clickedBtn === 3 ? 'btn-active' : ''} `}
            data-id="3"
            onClick={functionBtn}
          ><span
            className="material-symbols-outlined notranslate mI-modal-buttons">id_card
            </span>
          </button>

          <button
            className={`btn-modal-pages ${clickedBtn === 4 ? 'btn-active' : ''} `}
            data-id="4"
            onClick={functionBtn}>
            <span
              className="material-symbols-outlined notranslate mI-modal-buttons">info
            </span>
          </button>

        </div>



        {renderContent()}



      </div>

    </div>




  )
}
